// Social sharing helpers for launched tokens.

export const tokenPageUrl = (contractAddress, chainId) =>
  `${window.location.origin}/token/${contractAddress}${chainId ? `?chain=${chainId}` : ''}`;

// X (Twitter) web-intent URL — free marketing on every launch.
export const xShareUrl = (token) => {
  const text = `I just forged $${token.symbol} (${token.name}) on CoinForge — every trade pays the creator 0.5% forever. Liquidity is burned & locked.`;
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(tokenPageUrl(token.contract_address, token.chain_id))}`;
};
